<template>
  <div v-if="loaded" class="row">
  <!-- Réorganise ton formulaire ici -->
    <mh-input  autofocus mhClass="col-12" labelColsLg="0" field="content" :table="note"></mh-input>
    <b-col class="text-right mt-3">
      <b-button @click="$emit('close')">Annuler</b-button>
      <b-button @click="save" class="ml-3">Enregistrer</b-button>
    </b-col>
  </div>
</template>

<script>
import warrants from "@/services/warrants";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "WarrantNote",
  components: {
    MhInput,
  },
  props: {
    note_id: [Number, String],
    warrant_id: [Number, String],
    
    authorized: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      note: {},
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      warrants
        .note({
          warrant_id: this.warrant_id,
          note_id: this.note_id,
        })
        .then((response) => {
          this.note = response.data;
          this.loaded = true;
          if(this.note_id == 'new') {
            this.note.negotiateurID.value = 0;
          }
          if(this.note_id == 'new' && this.type !== '') {
            this.note.type.value = this.type;
          }
          this.note.type.options = this.note.type.options.filter( x => this.authorized.includes(x.value))
        });
    },
    
    save() {
      warrants.update_note({
        warrant_id: this.warrant_id,
        note_id: this.note_id,
        note: this.note
      }).then(response => {
        if (response.data.success) {
          this.$bvToast.toast("note mise à jour", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          for (let el in this.note) {
            if (this.note[el]) {
              this.note[el].error = false;
            }
          }
          this.$emit('change');
          this.$emit('close');
        } else if (response.data.fail) {
          for (let el in this.note) {
            if (this.note[el]) {
              this.note[el].error = false;
            }
          }
          response.data.fail.forEach((element) => {
            this.note[element.field].error = element.errors.join(" ; ");
          });
        } else if (response.data.error) {
          this.$bvToast.toast("Erreur : " + response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>